module.exports = "/_next/static/images/0b4ab0387c388028ed969f9553b2f7c4-cartao-proximo-ao-olho-xs@2x.jpg";